import $ from "jquery";
import slickInit from './modules/slick/slick';
import geoDealers from './modules/geolocation';
import ninjaForms from './modules/ninja-forms';

// Init Geolocation
window.initGoogleMaps = function () {
    if (!window.geo) {
        window.geo = new geoDealers();
    }
};

$(document).ready(function(){
    slickInit();


    if (typeof Marionette !== 'undefined' || $('.nf-form-cont').length) {
        ninjaForms();
        
        // Expose function globally for Google Maps callback
        window.initGoogleMaps = initGoogleMaps;
    }
    

    // Admin toolbar fix
    if ($('#wpadminbar')[0])
        $('header, .top-banner, html').addClass('wpadminbar-active');

    // Add smooth scrolling to all links
    $("a[href^='#']").on('click', function(event) {

        // Make sure this.hash has a value before overriding default behavior
        if (this.hash !== "" && typeof this.hash !== 'undefined') {
          // Prevent default anchor click behavior
          event.preventDefault();

          // Store hash
            var hash = this.hash;
            var scrollTo = $(hash).offset().top - 150;
            $('html, body').animate({
                scrollTop: scrollTo
            }, 800, function(){

          });
        } // End if
    });

    $('html').on('click', (e) => {
        var container = $('.menu-item-has-children > a');

        // If the click is NOT on a menu item or its children
        if (!container.is(e.target) && container.has(e.target).length === 0) {
            // Close visual state
            $('.menu-item-has-children > a, .icon-drop-down').removeClass('is-open');
            $('.sub-menu').slideUp().attr('aria-hidden', 'true');

            // Reset aria-expanded on all menu items
            $('.menu-item-has-children > a').attr('aria-expanded', 'false');
        }
    });

    // Main menu toggle
    $('.js-primary-menu').on('click', function(e) {
        e.preventDefault();

        // Menu functions
        $('.primary-menu').toggleClass('is-open');

        if ($(this).hasClass('menu-open')) {
            $('body').removeClass('menu-open');
            $(this).attr('aria-expanded', 'false');
        } else {
            $('body').addClass('menu-open');
            $(this).attr('aria-expanded', 'true');
        }

        $(this).toggleClass('menu-open');

        if ($('.site-header').hasClass('scroll')) {
            $('.site-header').removeClass('scroll');
        }

        if (!$(this).hasClass('menu-open') && ($(document).scrollTop() > 200)) {
            $('.site-header').addClass('scroll');
        }
    });

    // Submenu toggle
    $('.menu-item-has-children > a').on('click', function(e) {
        e.preventDefault();

        var thisMenu  = $(this).siblings('.sub-menu');
        var thisArrow = $(this).find('.icon-drop-down');

        // Close all other submenus
        $('.sub-menu').not(thisMenu).slideUp().attr('aria-hidden', 'true');
        $('.icon-drop-down').not(thisArrow).removeClass('is-open');
        $('.primary-menu-nav .menu-item-has-children > a')
            .not($(this))
            .removeClass('is-open')
            .attr('aria-expanded', 'false');

        // Toggle current submenu
        thisMenu.slideToggle();

        // Toggle aria-expanded on the current link
        var expanded = $(this).attr('aria-expanded') === 'true';
        $(this).attr('aria-expanded', !expanded);

        // Toggle aria-hidden on submenu
        thisMenu.attr('aria-hidden', expanded);

        // Toggle arrow state
        thisArrow.toggleClass('is-open');
        $(this).toggleClass('is-open');
    });

    if ($('.current-category').length > 0) {
        // Remove old selected clone if exists
        $('.current-category.selected').remove();

        // Clone current category into widget
        $('li.current-category')
            .clone()
            .prependTo('.categories.widget .cat-links')
            .addClass('selected')
            .attr({
                'role': 'button',
                'tabindex': '0',
                'aria-expanded': 'false',
            })
            .find('.children')
            .remove();
    }

    // Toggle on click
    $('.current-category.selected').on('click keypress', function (e) {
        // Handle Enter or Space key as well as click
        if (e.type === 'click' || e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();

            let $this = $(this);
            let expanded = $this.attr('aria-expanded') === 'true';

            $this.toggleClass('open');
            $this.attr('aria-expanded', !expanded);

            // Toggle sibling categories visibility
            let siblings = $this.siblings();
            siblings.slideToggle();
            siblings.attr('aria-hidden', expanded);
        }
    });


    $(window).on('scroll', function() {
        var scroll = $(window).scrollTop();
        var scrollVal = 120;

        if ($(window).width() <= 1024) {
            scrollVal = 60;
        }

        if (scroll >= scrollVal) {
            $(".site-header").addClass("is-sticky");
        } else {
            $(".site-header").removeClass("is-sticky");
        }
    });

     // Open all external links in a new window
     $("a[href^=http]").click(function(){
       if(this.href.indexOf(location.hostname) == -1) {
          $(this).attr({
             target: "_blank",
             title: "Opens in a new window"
          });
       }
    });

    // Social Popup
    $(".popup").click(function(event) {
      var width = 575,
        height = 400,
        left = ($(window).width() - width) / 2,
        top = ($(window).height() - height) / 2,
        url = this.href,
        opts =
          "status=1" +
          ",width=" +
          width +
          ",height=" +
          height +
          ",top=" +
          top +
          ",left=" +
          left;

      window.open(url, "twitter", opts);
      return false;
    });

});

$(window).on('load', function() {
    var scroll = $(window).scrollTop();
    var scrollVal = 120;

    if ($(window).width() <= 1024) {
        scrollVal = 60;
    }

    if (scroll >= scrollVal) {
        $(".site-header").addClass("is-sticky");
    }
});